import { createContext } from 'react';

export type Theme = 'light' | 'dark';

/** localStorage key. Also read by the pre-hydration script in index.html. */
export const THEME_STORAGE_KEY = 'sb3.theme';

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
